export class PasswordProtectedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PasswordProtectedError';
  }
}

export class PermissionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PermissionError';
  }
}

export class FileSizeError extends Error {
  readonly maxSize: number;
  readonly actualSize: number;

  constructor(message: string, maxSize: number, actualSize: number) {
    super(message);
    this.name = 'FileSizeError';
    this.maxSize = maxSize;
    this.actualSize = actualSize;
  }
}

export class FileTypeError extends Error {
  readonly contentType: string;

  constructor(message: string, contentType: string) {
    super(message);
    this.name = 'FileTypeError';
    this.contentType = contentType;
  }
}

export class MobileCaptureError extends Error {
  readonly source: 'camera' | 'gallery' | 'files';

  constructor(message: string, source: 'camera' | 'gallery' | 'files') {
    super(message);
    this.name = 'MobileCaptureError';
    this.source = source;
  }
}

/**
 * Enhanced error type with additional context properties added by DocumentService
 */
export interface EnhancedUploadError extends Error {
  sessionId?: string;
}
